import { useEffect } from 'react';

interface UseKeyboardShortcutsProps {
  onCommandPalette: () => void;
  onToggleSidebar: () => void;
}

export function useKeyboardShortcuts({ 
  onCommandPalette, 
  onToggleSidebar 
}: UseKeyboardShortcutsProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Command palette (Cmd+K or Ctrl+K)
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        onCommandPalette();
      }
      
      // Toggle sidebar (Cmd+B or Ctrl+B)
      if ((e.metaKey || e.ctrlKey) && e.key === 'b') {
        e.preventDefault();
        onToggleSidebar();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCommandPalette, onToggleSidebar]);
}